import { render, staticRenderFns } from "./MatterForm.vue?vue&type=template&id=330d9ee2&"
import script from "./MatterForm.vue?vue&type=script&lang=js&"
export * from "./MatterForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterForm.vue?vue&type=style&index=0&id=330d9ee2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports